<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 flex items-center justify-center z-50 rounded-[10px] max-[481px]:mx-[20px]"
  >
    <!-- Modal Overlay -->
    <div
      class="fixed inset-0 bg-[#80808086] bg-opacity-50 rounded-[10px]"
      @click="closeModal"
    ></div>

    <!-- Modal Content -->
    <div
      class="relative max-[481px]:h-auto  bg-white w-[1000px] max-[1000px]:w-full h-[696px] rounded-t-[10px] rounded-b-[10px] shadow-lg z-10"
    >
      <!-- Modal Header -->
      <div
        class="bg-[#9A247B] h-[45px] text-white pl-[20px] py-[12px] pr-[10px] flex justify-between items-center rounded-t-[10px]"
      >
        <h3 class="s !text-[14px]">ประวัติการเปิด-ปิดศูนย์พักพิง</h3>
        <button
          @click="closeModal"
          class="text-white hover:text-gray-200 bg-white rounded-full"
        >
          <CloseIcon class="w-6 h-6 text-primary" />
        </button>
      </div>

      <div class="p-[20px] pt-[12px]">
        <div class="pb-[10px]">
          <SearchBox
            id="search1"
            placeholder="ค้นหา ชื่อศูนย์พักพิง"
            class="h-[42px] mb-[10px]"
            v-model="searchQuery"
            @update:modelValue="onSearchChange"
          />
          <div class="flex gap-[10px] max-[481px]:flex-col">
            <!-- debug -->
            <!-- {{ date }} -->
            <DatePicker
              v-model="date"
              :placeholder="'เลือกช่วงเวลาที่กระทำ'"
              :enbaleTimePicker="false"
              :min-date="today"
              :max-date="null"
              class="!w-[257px] max-[481px]:!w-full"
              range
              @update:modelValue="onDateChange"
            />
            <SelectBox
              :searchable="true"
              placeholderClass="text-primary-dark"
              class="w-[141px] max-[481px]:!w-full"
              id="districtSelector"
              placeholder="แสดงทุกอำเภอ"
              :removable="true"
              optionToDisplay="districtNameTh"
              valueKey="districtCode"
              :provinceCode="57"
              @change="onDistrictChange"
            />
            <SelectBox
              placeholderClass="text-primary-dark"
              id="current3"
              placeholder="แสดงทุกการกระทำ"
              class="h-[42px] min-w-[163px]"
              :options="actionOptionsUi"
              @change="onActionChange"
            />
          </div>
        </div>

        <div class="w-full overflow-x-auto overflow-y-auto">
          <table class="min-w-[900px]">
            <thead>
              <tr>
                <th
                  class="w-[92px] h-[53px] text-left px-[10px] py-[16px] bg-primary text-[#FFFFFF] rounded-tl-[6px] border-r-[1px] border-solid border-[#FFFFFF] s !text-[14px]"
                >
                  วันที่กระทำ
                </th>
                <th
                  class="w-[54px] text-left px-[10px] py-[16px] bg-primary text-[#FFFFFF] border-r-[1px] border-solid border-[#FFFFFF] s !text-[14px]"
                >
                  เวลา
                </th>
                <th
                  class="w-[544px] text-left px-[10px] py-[16px] bg-primary text-[#FFFFFF] border-r-[1px] border-solid border-[#FFFFFF] s !text-[14px]"
                >
                  การกระทำ
                </th>
                <th
                  class="w-[270px] text-left px-[10px] py-[16px] bg-primary text-[#FFFFFF] rounded-tr-[6px] border-r-[1px] border-solid border-[#FFFFFF] s !text-[14px]"
                >
                  ชื่อผู้กระทำ
                </th>
              </tr>
            </thead>

            <tbody v-if="sheltersList.length > 0">
              <tr
                v-for="(row, index) in sheltersList"
                :key="index"
                class="h-[41px] s !text-[14px]"
                :class="['!border-none', { 'bg-[#FBEFF8]': (index + 1) % 2 === 0 }]"
              >
                <td
                  class="!border-none pl-[10px]"
                  :class="index === sheltersList.length - 1 ? 'rounded-bl-[6px]' : ''"
                >
                  {{ formatDate(row.created_at) }}
                </td>
                <td class="!border-none p-[10px]">
                  {{ formatTime(row.created_at) }}
                </td>
                <td class="!border-none p-[10px]">
                  {{ row.action_type }} {{ row.object }}
                </td>
                <td
                  class="!border-none p-[10px]"
                  :class="index === sheltersList.length - 1 ? 'rounded-br-[6px]' : ''"
                >
                  {{ row.created_by }}
                </td>
              </tr>
            </tbody>

            <tbody v-else>
              <tr>
                <td colspan="4" class="text-center py-6 text-[#DFDCDD] text-sm">
                  ไม่พบข้อมูล
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="">
          <paginationComponent
            class="mt-[10px]"
            :items="items"
            @selectedPage="handlePage"
          />
        </div>
      </div>
    </div>

    <!-- Modals -->
    <ShelterInfoModal
      v-if="showShelterInfo"
      :shelter="shelterData"
      :manage="true"
      @close="showShelterInfo = false"
    />
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onBeforeUnmount } from "vue";
import SearchBox from "@/components/Utilities/SearchBox.vue";
import ShelterInfoModal from "../Modals/ShelterInfoModal.vue";
import DatePicker from "@/components/Utilities/DatePicker.vue";
import axios from "axios";

// ===== props & emits =====
const props = defineProps({
  isOpen: { type: Boolean, default: false },
  data: { type: Array, default: () => [] },
});
const emit = defineEmits(["close", "selectedPage"]);

// ===== state =====
const searchQuery = ref("");
const date = ref(null); // จะได้ ['2025-08-01T09:31:00.000Z','2025-08-09T09:31:00.000Z'] แบบที่มึงว่า
const today = ref(null); // ถ้าจะล๊อคไม่ให้เลือกอดีตเปลี่ยนเป็น new Date()
const districtCode = ref(null); // เก็บรหัสอำเภอจาก selector
const actionType = ref(null); // 8 = เปิด, 9 = ปิด, null = ทุกอัน
const actionOptionsUi = ["แสดงทุกการกระทำ", "เปิดทำการ", "ปิดทำการ"];

const sheltersList = ref([]);
const shelterData = ref({});
const showShelterInfo = ref(false);
const items = ref(null);
const filters = ref({
  sort: "desc",
  paginate: 10,
  page: 1,
  per_page: 10,
});

// ===== computed (ถ้าจะกรองในหน้า เพิ่มได้) =====
const filteredShelters = computed(() => sheltersList.value);

// ===== lifecycle =====
watch(
  () => props.isOpen,
  (val) => {
    document.body.style.overflow = val ? "hidden" : "";
  },
  { immediate: true }
);
onBeforeUnmount(() => {
  document.body.style.overflow = "";
});

onMounted(async () => {
  await getDataHistory();
});

// ===== format helpers =====
function toYmd(dateStr) {
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return null;
  const yyyy = d.getUTCFullYear();
  const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(d.getUTCDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}
function formatDate(dateStr) {
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return "-";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear() + 543;
  return `${dd}-${mm}-${yyyy}`;
}
function formatTime(dateStr) {
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return "-";
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return `${hh}:${mi}`;
}

// ===== build params & fetch =====
async function getDataHistory() {
  try {
    const params = {};

    // ค้นหา
    if (searchQuery.value?.trim()) {
      params.search = searchQuery.value.trim();
    }

    // วันที่ (array 2 ตัว)
    if (Array.isArray(date.value) && date.value.length === 2) {
      const [startRaw, endRaw] = date.value;
      const startYmd = toYmd(startRaw);
      const endYmd = toYmd(endRaw);
      if (startYmd) params.start_date = startYmd;
      if (endYmd) params.end_date = endYmd;
    }

    // อำเภอ
    if (districtCode.value) {
      params.district_code = districtCode.value;
    }

    // การกระทำ
    if (actionType.value !== null) {
      params.action_type = actionType.value; // 8 | 9
    }

    // sort + page + paginate
    params.sort = filters.value.sort || "desc";
    params.page = filters.value.page || 1;
    if (filters.value.paginate) params.paginate = filters.value.paginate;

    const res = await axios.get("/shelter-history", { params });
    // สมมติ payload: { data: { data: [...], current_page, last_page, ... } }
    sheltersList.value = res?.data?.data?.data ?? [];
    // เก็บ meta ไว้ให้ paginate
    items.value = res?.data?.data ?? null;

    // console.log('params:', params, 'payload:', res.data)
  } catch (err) {
    console.error("getDataHistory error:", err);
  }
}

// ===== handlers =====
function closeModal() {
  emit("close");
  searchQuery.value = "";
  date.value = null;
  today.value = null;
  districtCode.value = null;
  actionType.value = null;
  getDataHistory();
}

function onSearchChange() {
  filters.value.page = 1;
  getDataHistory();
}

function onDateChange() {
  filters.value.page = 1;
  getDataHistory();
}

function onDistrictChange(option) {
  // option: { districtNameTh, districtCode } หรือ null
  districtCode.value = option?.districtCode ?? null;
  filters.value.page = 1;
  getDataHistory();
}

function onActionChange(optionText) {
  // 'แสดงทุกการกระทำ' | 'เปิดทำการ' | 'ปิดทำการ'
  if (optionText === "เปิดทำการ") actionType.value = 8;
  else if (optionText === "ปิดทำการ") actionType.value = 9;
  else actionType.value = null;
  filters.value.page = 1;
  getDataHistory();
}

async function handlePage(page) {
  //   items.value.current_page = page
  filters.value.page = page;
  await getDataHistory();
}
</script>
